import { render, staticRenderFns } from "./ProjectBrands.vue?vue&type=template&id=0daae43d"
import script from "./ProjectBrands.vue?vue&type=script&lang=ts"
export * from "./ProjectBrands.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports